module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/2a760918afd6de89eec4e43b4fa073d9.png";